import { Pipe, PipeTransform } from "@angular/core";

/**
 * Pipe que substitui um caractere TAB em uma determinada entrada por uma entidade HTML de tabulação.
 *
 * @author Luciano Alves
 */
@Pipe({ name: "replaceTab" })
export class ReplaceTabPipe implements PipeTransform {
    transform(input: string): string {
        return input.replace(/\t/g, "&emsp;");
    }
}
